import { Injectable, inject } from '@angular/core';
import { DialogService } from '../dialog/dialog.service';
import ActionSheetComponent from './action-sheet.component';
import { ActionSheetProps } from './action-sheet.type';
import { IModal } from '../../services/modal/modal.interface';

@Injectable({ providedIn: 'root' })
export class ActionSheetService implements IModal {
  private readonly dialogService = inject(DialogService);

  create(props: ActionSheetProps) {
    const actionSheet = this.dialogService.show({
      component: ActionSheetComponent,
      componentProps: {
        ...props,
      },
    });

    return actionSheet;
  }

  close(data?: any) {
    this.dialogService.dismiss(data);
  }
}
